import { render, staticRenderFns } from "./violationManagementConfig.vue?vue&type=template&id=b6999cf8&scoped=true"
import script from "./violationManagementConfig.vue?vue&type=script&lang=js"
export * from "./violationManagementConfig.vue?vue&type=script&lang=js"
import style0 from "./violationManagementConfig.vue?vue&type=style&index=0&id=b6999cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6999cf8",
  null
  
)

export default component.exports